import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { User } from 'src/app/classes/user.class';
import { Address, LocationService } from 'src/app/services/location.service';
import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'app-address-icon',
    templateUrl: './address-icon.component.html',
    styleUrls: ['./address-icon.component.scss'],
    standalone: false,
})
export class AddressIconComponent implements OnChanges {
    @Input() users: User[];
    @Input() userId: number | null | undefined;
    @Input() address: string | null | undefined;
    @Input() location: string | null | undefined;

    protected icon: 'house-user' | 'company' | 'hotel' | 'person-digging';

    constructor(private locationService: LocationService) {}

    ngOnChanges(changes: SimpleChanges): void {
        const companyAddress = this.locationService.formatAddress(environment.companyAddress);
        const userAddress = this.locationService.formatAddress(this.users.find(u => u.id === this.userId) as Address);

        if (
            changes?.location?.currentValue?.toLowerCase() === this.address?.toLowerCase() ||
            this.location?.toLowerCase() === changes?.address?.currentValue?.toLowerCase()
        ) {
            this.icon = 'person-digging';
        } else if (companyAddress?.toLowerCase() === this.address?.toLowerCase()) {
            this.icon = 'company';
        } else if (userAddress?.toLowerCase() === this.address?.toLowerCase()) {
            this.icon = 'house-user';
        } else if (this.address) {
            this.icon = 'hotel';
        }
    }
}
